<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header"><h5>Отказы у курьеров</h5></div>
      <div class="card-body">
        <div class="flex flex_gap_10 justify-content-between">
          <div class="flex flex_gap_10 flex-wrap">
            <div class="flex-grow-1">
              <label for="">Дивизионы</label>
              <multiselect
                v-model="selectedDivisions"
                :options="divisionsForSelect"
                track-by="title"
                label="title"
                :show-labels="false"
                placeholder="Любой дивизион"
                :multiple="true">
              </multiselect>
            </div>
            <div>
              <label for="">Интервал</label>
              <div>
                <DateRangePicker ref="dateRange"/>
              </div>
            </div>
          </div>
          <div>
            <LoadingButton
              title="Показать"
              className="btn btn-outline-info"
              :color="$constants.LOADING_COLOR"
              :loading="loadingBtn"
              :onClick="() => getRecords()"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loadingBtn && !records.length" :color="$constants.LOADING_COLOR" class="text-center"/>
        <table class="table m-0 table-sm table-hover">
          <thead>
          <tr>
            <th></th>
            <th>Дивизион</th>
            <th>Курьер</th>
            <th>проект</th>
            <th>Заявка</th>
            <th>Отказ</th>
            <th>Дата</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(r, i) in records">
            <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
            <td>{{ $AllDivisions[r.division_id]?.title ?? 'Не определен дивизион' }}</td>
            <td>
              {{ r.courier_name ?? 'не назначен' }}
            </td>
            <td>{{ r.project_label ?? 'Не определен'}}</td>
            <td>
              <button
                @click="openOrderToEdit(r.id)"
                class="btn btn-xs btn-info ml-1 mr-2"
              >
                <i class="icon-fa icon-fa-eye"></i>
              </button>
              {{ r.id }}
            </td>
            <td>{{ r.reject_comment }}</td>
            <td>{{ printDate(r.report_date) }}</td>
          </tr>
          </tbody>
        </table>

        <div>
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    :page-range="8"
                    :margin-pages="3"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import DateRangePicker from "@/components/dateSelect/DateRangePicker.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import Paginate from 'vuejs-paginate'
import api from "@/api";
import UserName from "@/components/users/UserName.vue";

export default {
  components: {
    UserName,
    LoadingButton,
    DateRangePicker,
    Multiselect,
    Paginate,
  },
  data() {
    return {
      selectedDivisions: [],
      divisionsForSelect: [],
      records: [],
      paginator: null,
      loadingBtn: false,
    }
  },
  computed: {
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    }
  },
  created() {
    this.divisionsForSelect = _.orderBy(Object.values(this.$AllDivisions).filter((d) => d.is_active), 'title');
  },
  methods: {
    async getRecords(page = 1) {
      this.loadingBtn = true;
      const filter = {
        divisions: this.selectedDivisions.map((d) => d.id),
        range: this.$refs.dateRange.dateRange
      };
      let {data: r_data} = await api.post('/new/orders/list/rejected', {page, filter});
      const {data, ...pagination} = r_data.records
      this.paginator = pagination;
      this.records = data;
      this.loadingBtn = false;

    }
  }
}

</script>
